import type { RenderedView } from '../router.js';
import { navigate } from '../router.js';
import { repos } from '../store.js';
import { esc, onClick } from '../dom.js';
import { icon } from '../icons.js';
import { classFormDialog } from '../classForm.js';

export async function classesView(): Promise<RenderedView> {
  const classes = await repos.listClasses();

  const create = () => classFormDialog({ onDone: (c) => navigate(`#/class/${c.id}`) });

  const body = classes.length
    ? `<ul class="list">${classes
        .map(
          (c) => `<button class="row" data-id="${esc(c.id)}"><span class="grow"><span class="ttl">${esc(c.name)}</span>
          <span class="meta">Grade ${esc(c.gradeLevel)} · ${esc(c.schoolYear)}</span></span><span class="chev">${icon.chevron()}</span></button>`,
        )
        .join('')}</ul>`
    : `<div class="empty">${icon.users()}<p>No classes yet.</p><button class="btn btn-primary" data-new>${icon.plus()} New class</button></div>`;

  return {
    title: 'Classes',
    tab: 'class',
    html: `<div class="view">
      <button class="btn btn-primary btn-block" data-new>${icon.plus()} New class</button>
      <div style="height:12px"></div>${body}</div>`,
    mount(root) {
      onClick(root, '.row[data-id]', (el) => navigate(`#/class/${el.dataset.id}`));
      onClick(root, '[data-new]', create);
    },
  };
}
